import { Extension } from '@tiptap/core';
import type { Editor, Range } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion from '@tiptap/suggestion';

// https://codesandbox.io/p/sandbox/tiptap-react-slash-command-e3j3u?file=%2Fsrc%2Fstyles.css%3A7%2C20

const memoSlashCommandSuggestionPluginKey = new PluginKey('memoSlashCommandSuggestion');

interface MemoCommandSelection {
    command: (context: { editor: Editor; props: MemoCommandSelection; range: Range }) => void;
}

const Commands = Extension.create({
    name: 'mention',

    addOptions() {
        return {
            suggestion: {
                char: '/',
                pluginKey: memoSlashCommandSuggestionPluginKey,
                startOfLine: false,
                command: ({ editor, range, props }: { editor: Editor; props: MemoCommandSelection; range: Range }) => {
                    props.command({ editor, range, props });
                },
            },
        };
    },

    addProseMirrorPlugins() {
        return [
            Suggestion<MemoCommandSelection, MemoCommandSelection>({
                editor: this.editor,
                ...this.options.suggestion,
                pluginKey: memoSlashCommandSuggestionPluginKey,
            }),
        ];
    },
});

export default Commands;
